import { ClientConstructionSite } from "@dune/types";
import { ColumnDef } from "@tanstack/react-table";

export const clientConstructionSiteColumns =
	(): ColumnDef<ClientConstructionSite>[] => [
		{
			accessorKey: "ref",
			header: "Ref",
			cell: ({ row }) => <div className="font-medium">{row.original.ref}</div>,
		},
		{
			accessorKey: "projectOwner",
			header: "Maître d'ouvrage",
			cell: ({ row }) => {
				const projectOwner = row.original.projectOwner;
				const truncatedText =
					projectOwner && projectOwner.length > 15
						? `${projectOwner.substring(0, 15)}...`
						: projectOwner;

				return (
					<span title={projectOwner} className="block max-w-[120px] truncate">
						{truncatedText}
					</span>
				);
			},
		},
		{
			accessorKey: "projectType",
			header: "Type de projet",
			cell: ({ row }) => <span>{row.original.projectType}</span>,
		},
		{
			accessorKey: "siteType",
			header: "Type de chantier",
			cell: ({ row }) => <span>{row.original.siteType}</span>,
		},
		{
			accessorKey: "cost",
			header: "Coût",
			cell: ({ row }) => (
				<span
					className={`font-medium ${row.original.cost === "N/A" ? "text-gray-400" : ""}`}
				>
					{row.original.cost}
				</span>
			),
		},
		{
			accessorKey: "address",
			header: "Adresse",
			cell: ({ row }) => (
				<span
					className={`text-sm ${row.original.address === "N/A" ? "text-gray-400" : ""}`}
				>
					{row.original.address}
				</span>
			),
		},
		{
			accessorKey: "status",
			header: "Statut",
			cell: ({ row }) => {
				const status = row.original.status;
				let statusClass = "px-2 py-1 rounded-full text-xs font-medium ";

				switch (status) {
					case "En cours":
						statusClass += "bg-blue-100 text-blue-800";
						break;
					case "À analyser":
						statusClass += "bg-orange-100 text-orange-800";
						break;
					case "Validé":
						statusClass += "bg-green-100 text-green-800";
						break;
					default:
						statusClass += "bg-gray-100 text-gray-800";
				}

				return <span className={statusClass}>{status}</span>;
			},
		},
		{
			accessorKey: "createdAt",
			header: "Créé",
			cell: ({ row }) => <span>{row.original.createdAt}</span>,
		},
		{
			accessorKey: "product",
			header: "Produit",
			cell: ({ row }) => (
				<span
					className={`text-sm ${row.original.product === "N/A" ? "text-gray-400" : ""}`}
				>
					{row.original.product}
				</span>
			),
		},
		{
			accessorKey: "totalPremium",
			header: "Prime TTC",
			cell: ({ row }) => (
				<span
					className={`font-medium ${row.original.totalPremium === "N/A" ? "text-gray-400" : ""}`}
				>
					{row.original.totalPremium}
				</span>
			),
		},
	];
